import { useDedaloApi } from '@/hooks/api/useDedaloApi';
import { PhotosSchema, DocumentsSchema } from '@/schemas/documentsSchema';

export function usePhotos(ids) {
    const options = {
        table: 'documents',
        ar_fields: ['identify_image','identify_image_caption'],
        section_id: ids,
        sql_filter: "format LIKE '%Pre_fotografía%'"
    };

    return useDedaloApi(options, PhotosSchema);
}

export function useDocuments(ids) {
    const options = {
        table: 'documents',
        ar_fields: ['identify_image','identify_image_caption'],
        section_id: ids,
        sql_filter: "format LIKE '%Pre_documento%'"
    };

    return useDedaloApi(options, DocumentsSchema);
}